/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { userSessionClientsList } from "../funcs/userSessionClientsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import {
  ListUserSessionClientsRequest,
  ListUserSessionClientsResponse,
  ListUserSessionClientsSecurity,
} from "../models/operations/listusersessionclients.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";
import { pageIteratorToJSON } from "./_types.js";
export type UserSessionClientsQueryData = ListUserSessionClientsResponse;

export type UserSessionClientsInfiniteQueryData = PageIterator<
  ListUserSessionClientsResponse,
  { cursor: string }
>;

export type UserSessionClientsPageParams = PageIterator<
  ListUserSessionClientsResponse,
  { cursor: string }
>["~next"];

export function prefetchUserSessionClients(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListUserSessionClientsRequest | undefined,
  security?: ListUserSessionClientsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildUserSessionClientsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function prefetchUserSessionClientsInfinite(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListUserSessionClientsRequest | undefined,
  security?: ListUserSessionClientsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchInfiniteQuery({
    ...buildUserSessionClientsInfiniteQuery(
      client$,
      request,
      security,
      options,
    ),
    initialPageParam: undefined as UserSessionClientsPageParams,
    getNextPageParam: (previousPage: UserSessionClientsInfiniteQueryData) =>
      previousPage["~next"],
  });
}

export function buildUserSessionClientsQuery(
  client$: GramCore,
  request?: ListUserSessionClientsRequest | undefined,
  security?: ListUserSessionClientsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<UserSessionClientsQueryData>;
} {
  return {
    queryKey: queryKeyUserSessionClients({
      userSessionIssuerId: request?.userSessionIssuerId,
      cursor: request?.cursor,
      limit: request?.limit,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function userSessionClientsQueryFn(
      ctx,
    ): Promise<UserSessionClientsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(userSessionClientsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function buildUserSessionClientsInfiniteQuery(
  client$: GramCore,
  request?: ListUserSessionClientsRequest | undefined,
  security?: ListUserSessionClientsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext<QueryKey, UserSessionClientsPageParams>,
  ) => Promise<UserSessionClientsInfiniteQueryData>;
} {
  return {
    queryKey: queryKeyUserSessionClientsInfinite({
      userSessionIssuerId: request?.userSessionIssuerId,
      cursor: request?.cursor,
      limit: request?.limit,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function userSessionClientsQuery(
      ctx,
    ): Promise<UserSessionClientsInfiniteQueryData> {
      const sig = combineSignals(ctx.signal, options?.fetchOptions?.signal);
      const mergedOptions = {
        ...options,
        fetchOptions: { ...options?.fetchOptions, signal: sig },
      };

      if (!ctx.pageParam) {
        const pageResult = await unwrapResultIterator(userSessionClientsList(
          client$,
          request,
          security,
          mergedOptions,
        ));
        return pageIteratorToJSON(pageResult);
      }
      const pageResult = await unwrapResultIterator(userSessionClientsList(
        client$,
        {
          ...request!,
          cursor: ctx.pageParam.cursor,
        },
        security,
        mergedOptions,
      ));
      return pageIteratorToJSON(pageResult);
    },
  };
}

export function queryKeyUserSessionClients(
  parameters: {
    userSessionIssuerId?: string | undefined;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "userSessionClients", "list", parameters];
}

export function queryKeyUserSessionClientsInfinite(
  parameters: {
    userSessionIssuerId?: string | undefined;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "userSessionClients", "list", "infinite", parameters];
}
